import { render, staticRenderFns } from "./UpsellDisplayCard.vue?vue&type=template&id=b762d03a"
import script from "./UpsellDisplayCard.vue?vue&type=script&lang=js"
export * from "./UpsellDisplayCard.vue?vue&type=script&lang=js"
import style0 from "./UpsellDisplayCard.vue?vue&type=style&index=0&id=b762d03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports